import React from "react";
import AntdCard, {CardProps} from "antd/lib/card";
import {withError} from '@fishx/tracker';

const Grid = AntdCard.Grid;
const Meta = AntdCard.Meta;
interface FCCardProps extends React.FC<CardProps> {
  Grid:typeof Grid;
  Meta:typeof Meta;
}
export const Card:FCCardProps  = (props) =>{
  return <AntdCard {...props} />;
}
Card.Grid = Grid;
Card.Meta = Meta;
Card.displayName = 'Card';
export default withError(Card);


// WEBPACK FOOTER //
// ./src/components/card/index.tsx